import React from 'react';

function AppleIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.68 24" width="22" height="22" fill="currentColor">
			<g>
				<path
					d="M6.53,24C3,24,0,16.69,0,13,0,6.91,4.55,5.58,6.3,5.58a7.3,7.3,0,0,1,2.38.59A5.3,5.3,0,0,0,10,6.56a4.79,4.79,0,0,0,1-.32A7.65,7.65,0,0,1,14,5.53h0a6,6,0,0,1,5,2.54l.37.55L18.83,9a4.41,4.41,0,0,0-2.13,3.66A4.13,4.13,0,0,0,19,16.52c.33.2.67.4.67.86,0,.29-2.34,6.58-5.74,6.58A4.46,4.46,0,0,1,12,23.49a4,4,0,0,0-1.73-.41,4.43,4.43,0,0,0-1.37.37A6.62,6.62,0,0,1,6.55,24Z"/>
				<path d="M14.31,0c.09,3.19-2.19,5.41-4.47,5.27C9.46,2.72,12.12,0,14.31,0Z"/>
			</g>
		</svg>
	);
}

export default AppleIcon;